import React from 'react';
import { Container } from 'reactstrap';
import NavMenu from './NavMenu';
import Bottom from './Bottom';

export default props => (
  <div>
    <NavMenu />
    <Container fluid={true} >
      <div className='main-container' style={{ minHeight: '300px' }}>
        {props.children}
      </div>
    </Container>
    <Bottom />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Layout.js